<template>
  <div class="kn-empty" :class="{'kn-empty--compact': compact}">
    <div class="kn-empty__icon">
      <i :class="icon"></i>
    </div>
    <div class="kn-empty__title">{{ title }}</div>
    <div v-if="description || $slots.default" class="kn-empty__description">
      <slot>{{ description }}</slot>
    </div>
    <div v-if="$slots.actions" class="kn-empty__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "empty-state",
  props: {
    title: {type: String, default: 'Здесь пока пусто'},
    description: {type: String, default: null},
    icon: {type: String, default: 'far fa-folder-open'},
    compact: {type: Boolean, default: false},
  },
}
</script>

<style lang="scss">
.kn-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  color: var(--kn-text-muted);

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    margin-bottom: 16px;
    border-radius: 16px;
    background-color: var(--kn-primary-soft);
    color: var(--kn-primary);
    font-size: 22px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--kn-text);
  }

  &__description {
    max-width: 420px;
    margin-top: 6px;
    font-size: 14px;
    line-height: 1.5;
  }

  &__actions {
    display: flex;
    gap: 8px;
    margin-top: 20px;
  }

  &--compact {
    padding: 24px 16px;
  }

  &--compact &__icon {
    width: 44px;
    height: 44px;
    font-size: 18px;
    margin-bottom: 10px;
  }
}
</style>
